/**
 * Commands
 * Ribbon button command handlers
 */

// Office.js is loaded via HTML script tag
// This file is for any command functions that might be needed

Office.onReady(() => {
  // Commands are ready
  console.log('Solvia iTop Add-in commands loaded');
});

// Export empty to make this a module
export {};
